// src/hooks/useSearchSuggestions.js
/**
 * Custom hook for search suggestions
 */
import { useState, useEffect, useCallback } from "react";

export const useSearchSuggestions = (
  inventory = [],
  showSuggestions = true
) => {
  const [suggestions, setSuggestions] = useState([]);
  const [searchHistory, setSearchHistory] = useState([]);

  const generateSearchSuggestions = useCallback(async () => {
    try {
      // Generate contextual suggestions based on inventory
      const categories = [...new Set(inventory.map((item) => item.category))];
      const dynamicSuggestions = [];

      if (categories.includes("wine")) {
        dynamicSuggestions.push(
          "Find me something like a Pinot Noir but lighter",
          "Bold red wines for a romantic dinner",
          "Unique wines from small producers"
        );
      }

      if (categories.includes("cocktail")) {
        dynamicSuggestions.push(
          "Light summer cocktails with gin",
          "Classic cocktails for a business meeting"
        );
      }

      if (categories.includes("beer")) {
        dynamicSuggestions.push(
          "Craft beers from local breweries",
          "Light beers for casual dining"
        );
      }

      // Add price-based suggestions
      dynamicSuggestions.push(
        "What pairs well with seafood under $40?",
        "Celebration drinks under $100"
      );

      setSuggestions(dynamicSuggestions.slice(0, 6));
    } catch (error) {
      console.error("Error generating suggestions:", error);
      // Fallback suggestions
      setSuggestions([
        "Popular wines",
        "Light and refreshing",
        "Bold and rich",
        "Perfect for celebrations",
        "Great value options",
        "Sommelier recommendations",
      ]);
    }
  }, [inventory]);

  useEffect(() => {
    if (showSuggestions && inventory.length > 0) {
      generateSearchSuggestions();
    }
  }, [inventory, showSuggestions, generateSearchSuggestions]);

  const addToHistory = useCallback((query, resultCount) => {
    const newHistoryItem = {
      query,
      timestamp: Date.now(),
      resultCount,
    };
    setSearchHistory((prev) => [newHistoryItem, ...prev.slice(0, 4)]); // Keep last 5
  }, []);

  return {
    suggestions,
    searchHistory,
    addToHistory,
  };
};
